import { render, staticRenderFns } from "./SetupNav.vue?vue&type=template&id=10784eac&"
import script from "./SetupNav.vue?vue&type=script&lang=js&"
export * from "./SetupNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports